import React, { useEffect, useState } from 'react';
import { bbox } from '@turf/turf';
import MapGta from './MapGta';
import MapWorld from './MapWorld';
import { _$ } from '../../../controllers/dom';
import { createMarker } from '../../../controllers/markers';

const Map = (props) => {
    const { map, data, setClickData, cityFocused, marker, setMarker, gtaMapType } = props;
    const [mapObject, setMapObject] = useState(null);
    const [departmentsDisplayed, setDepartmentsDisplayed] = useState([]);

    const getGtaVGeoJson = () => {

    };
    const getDeptGeoJson = () => {
        for (const dept of departmentsDisplayed) {
            if (mapObject.getSource('department' + dept)) {
                mapObject.removeLayer('department-fill' + dept);
                mapObject.removeSource('department' + dept);
            }
        }
        data.departments.forEach((dept) => {
            fetch(`https://api.alertes-speciales.fr/geojson/departement/${dept}?access_token=39bb82568645b321ee454f41e1d413f66c10a54090b1c0d2eb844ad8332ab3ca`) // eslint-disable-line
                .then((response) => response.json())
                .then((geojson) => {
                    setDepartmentsDisplayed([...departmentsDisplayed, dept]);
                    mapObject.addSource('department' + dept, {
                        type: 'geojson',
                        data: geojson,
                    });

                    mapObject.addLayer({
                        id: 'department-outline' + dept,
                        type: 'line',
                        source: 'department' + dept,
                        layout: {},
                        paint: {
                            'line-color': '#088',
                            'line-width': 2,
                        },
                    });
                    mapObject.fitBounds(bbox(geojson), { padding: 50 }, { maxZoom: 10 });
                })
                .catch((error) => console.error(`Erreur lors du chargement du département ${dept}:`, error));
        });
    };

    useEffect(() => {
        if (cityFocused && mapObject) {
            if (mapObject.getLayer('city-outline')) mapObject.removeLayer('city-outline');
            if (mapObject.getSource('city')) mapObject.removeSource('city');
            let urlSrc = '';
            if (map === 'worldMap') {
                urlSrc = `https://api.alertes-speciales.fr/geojson/commune/${cityFocused.toUpperCase().replace(/ /g, '-')}?access_token=39bb82568645b321ee454f41e1d413f66c10a54090b1c0d2eb844ad8332ab3ca`; // eslint-disable-line
            } else {
                urlSrc = 'https://api.alertes-speciales.fr/gtageojson/area/?access_token=39bb82568645b321ee454f41e1d413f66c10a54090b1c0d2eb844ad8332ab3ca';
            }
            fetch(urlSrc)
                .then((response) => response.json())
                .then((geojson) => {
                    if (map === 'gtaMap') {
                        const geojsonFeatures = geojson.features.filter((feature) => feature.properties.name.toUpperCase() === cityFocused);
                        geojson = geojsonFeatures[0];
                        geojson.geometry.coordinates[0].push(geojson.geometry.coordinates[0][0]);
                    }
                    mapObject.addSource('city', {
                        type: 'geojson',
                        data: geojson,
                    });
                    mapObject.addLayer({
                        id: 'city-outline',
                        type: 'line',
                        source: 'city',
                        layout: {},
                        paint: {
                            'line-color': '#088',
                            'line-width': 2,
                        },
                    });
                    mapObject.fitBounds(bbox(geojson), { padding: 50 }, { maxZoom: 10 });
                })
                .catch((error) => console.error(`Erreur lors du chargement de la commune ${cityFocused}:`, error));
        }
    }, [cityFocused]);

    useEffect(() => {
        if (_$('map')) _$('map').style.width = '100%';
        if (data.departments.length > 0 && mapObject) {
            if (map === 'worldMap') {
                if (!mapObject.loaded()) {
                    mapObject.on('load', () => {
                        if (map === 'worldMap') {
                            getDeptGeoJson();
                        } else {
                            getGtaVGeoJson();
                        }
                    });
                } else {
                    if (map === 'worldMap') {
                        getDeptGeoJson();
                    } else {
                        getGtaVGeoJson();
                    }
                }
            }
            mapObject.on('click', (e) => {
                setClickData(e);
            });
        }
    }, [map, mapObject]);

    useEffect(() => {
        if (marker && mapObject && marker !== 'OK') {
            const execute = async () => {
                await createMarker(
                    mapObject,
                    marker.lngLat,
                    marker.title,
                    marker.content,
                    marker.icon,
                    marker.id,
                    marker.callback,
                    marker.flyTo,
                );
                setMarker('OK');
            };
            execute();
        }
    }, [marker, mapObject]);

    return (
        <div>
            {map === 'gtaMap' ?
                <MapGta
                    setMapObject={setMapObject}
                    mini={false}
                    mapType={gtaMapType}
                /> : map === 'worldMap' ?
                    <MapWorld
                        setMapObject={setMapObject}
                        mini={false}
                    /> :
                    ''}
        </div>
    );
};

export default Map;
